// Virkailijaportaali/src/api/augmentoiTukipyynto.ts
import type { Tukipyynto } from "../types";

/** Backend palauttaa nyt kaikki kentät (ml. kasittelyhistoria) suoraan.
 *  Tämä funktio vain varmistaa että kasittelyhistoria on aina array
 *  (vanhat tiketit voivat puuttua sen). Ei enää mockdatan generointia. */
export type TukipyyntoRaaka = Omit<Tukipyynto, "kasittelyhistoria"> & {
  kasittelyhistoria?: Tukipyynto["kasittelyhistoria"];
};

export function augmentoiTukipyynto(raw: TukipyyntoRaaka): Tukipyynto {
  return {
    ...raw,
    kasittelyhistoria: raw.kasittelyhistoria ?? [],
  };
}
